import React, { FC } from 'react';

const UpArrow: FC = () => (
  <svg
    width='14'
    height='7'
    viewBox='0 0 14 7'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 6L7 2L13 6'
      stroke='#1E213F'
      strokeOpacity='0.25'
      strokeWidth='2'
    />
  </svg>
);

export default UpArrow;
